/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { LinkedInProfileViewTaskCreatePriority } from './linkedInProfileViewTaskCreatePriority';
import type { LinkedInProfileViewTaskCreateTaskNoteDoc } from './linkedInProfileViewTaskCreateTaskNoteDoc';

export interface LinkedInProfileViewTaskCreate {
  job_id: string;
  candidate_id: string;
  assignee_user_id: string;
  due_at?: string | null;
  priority?: LinkedInProfileViewTaskCreatePriority;
  title?: string | null;
  type: 'linkedin_profile_view';
  linkedin_account_id?: string | null;
  target_linkedin_url?: string | null;
  task_note_doc?: LinkedInProfileViewTaskCreateTaskNoteDoc;
}
